import { NotificationManager } from "react-notifications";
import { Actions as DEPUTY_ACTIONS } from "@/integrations/deputy/store/deputyActions";
import { Actions as TANDA_ACTIONS } from "@/integrations/workforce/store/workforceActions";
import { Actions as BAMBOO_ACTIONS } from "@/integrations/bamboo-hr/store/bambooActions";
import { Actions as XERO_ACTIONS } from "@/integrations/xero/store/xeroActions";
import { Actions as QUICKBOOKS_ACTIONS } from "@/integrations/quickbooks/store/quickbooksActions";
import { Actions as SMART_PENSION_ACTIONS } from "@/integrations/smartPension/store/smartPensionActions";
import _ from "lodash";
import { createRequest } from "@/components/common/helpers/RequestHelpers";

import apiURL from "./apiURL";
import axios from "axios";

const integrationsRequest = createRequest({
	urlPath: "/integrations",
	//   local: true
});

const Types = {
	INTEGRATION_UPDATE_PAYROLL_HISTORY: "INTEGRATION_UPDATE_PAYROLL_HISTORY",
	INTEGRATION_GET_LIST: "INTEGRATION_GET_LIST",
	INTEGRATION_EMPLOYEE_LINK: "INTEGRATION_EMPLOYEE_LINK",
	INTEGRATION_IMPORT_MODAL: "INTEGRATION_IMPORT_MODAL",
	INTEGRATION_USER_CONNECTED_ORGS_MODAL: "INTEGRATION_USER_CONNECTED_ORGS_MODAL",
	INTEGRATION_USER_CONNECTED_ORGS: "INTEGRATION_USER_CONNECTED_ORGS",
	INTEGRATION_BULK_LINK_MODAL: "INTEGRATION_BULK_LINK_MODAL",
};

const updatePayrolLHistory = (periodId, paymentStatus) => ({
	type: Types.INTEGRATION_UPDATE_PAYROLL_HISTORY,
	periodId,
	paymentStatus,
});

const updateIntegrationList = (response) => ({
	type: Types.INTEGRATION_GET_LIST,
	response,
});

const updateConnectedUserOrgs = (response) => ({
	type: Types.INTEGRATION_USER_CONNECTED_ORGS,
	response,
});

const toggleImportModal = (status) => ({
	type: Types.INTEGRATION_IMPORT_MODAL,
	status,
});

const toggleBulkLinkModal = (status) => ({
	type: Types.INTEGRATION_BULK_LINK_MODAL,
	status,
});

const switchEmployeeLink = (employee, integration) => ({
	type: Types.INTEGRATION_EMPLOYEE_LINK,
	employee,
	integration,
});

const linkEmployee = () => {
	return (dispatch, getState) => {
		const state = getState();
		const agreement = state.employee?.agreementInfo?.id;

		const integrations = Object.values(state.integration || {})?.reduce((prev, curr) => {
			Object.values(curr || {})?.map((item) => {
				if (item.name) prev.push(item.name);
			});
			return prev;
		}, []);

		if (state.deputy.connected) integrations.push("Deputy");

		integrations.map((integration) => {
			const referenceLink = state.employee[`${_.camelCase(integration)}Link`];
			if (!agreement || !referenceLink) return;

			switch (integration) {
				case "Deputy":
					dispatch(DEPUTY_ACTIONS.linkDeputyEmployee({ agreement, deputyId: referenceLink }));
					break;
				case "Tanda":
					dispatch(TANDA_ACTIONS.linkEmployee({ agreement, referenceLink }));
					break;
				case "Bamboo HR":
					dispatch(BAMBOO_ACTIONS.linkEmployee({ agreement, referenceLink }));
					break;
				case "Quickbooks":
					dispatch(QUICKBOOKS_ACTIONS.linkEmployee({ agreement, referenceLink }));
					break;
				case "Smart Pension":
					dispatch(SMART_PENSION_ACTIONS.linkEmployee({ agreement, referenceLink }));
					break;
			}
		});

		dispatch(switchEmployeeLink());
	};
};

const getLinkedOrgIntegrations = (id) => {
	return (dispatch, getState) => {
		let state = getState();

		fetch(apiURL + `/integrations/${id}/linked-organisations`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(updateConnectedUserOrgs(data));
			})
			.catch((error) => {
				console.error(error);
			});
	};
};

const disconnectLinkedOrg = (id) => {
	return (dispatch, getState) => {
		let state = getState();

		integrationsRequest({
			method: "DELETE",
			path: `/${id}/linked-organisation`,
		}).then(({ data }) => {
			const linkedOrganisations = state.my?.userConnectedOrgs?.filter(
				({ id: integrationId }) => integrationId !== id,
			);
			dispatch(updateConnectedUserOrgs({ linkedOrganisations }));
		}).catch((error) => {
			console.error(error);
			NotificationManager.error("Error Disconnecting Organisation", "Disconnecting Organisation");
		});
	};
};

const openUserConnectedOrgsModal = (integration) => ({
	type: Types.INTEGRATION_USER_CONNECTED_ORGS_MODAL,
	integration,
});

const integrationGetList = () => {
	return (dispatch, getState) => {
		integrationsRequest({
			method: "GET",
			path: `/list`,
		}).then(({ data }) => {
			// TODO remove deputy and Xero once they have been joined in
			dispatch(DEPUTY_ACTIONS.isConnectedWithDeputy());
			dispatch(XERO_ACTIONS.isConnectedToXero());
			dispatch(updateIntegrationList(data));
		});
	};
};

const sendPayment = (periodId, transferDate) => {
	return (dispatch, getState) => {
		let state = getState();

		const integration = state?.integration?.payments?.name;

		fetch(apiURL + `/integrations/${integration?.toLowerCase()}/send-payments`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
			body: {
				periodId,
				transferDate,
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(updatePayrolLHistory(periodId, data));
				NotificationManager.success(`Successfully Sent Payments to ${integration}`, "Sending Payments");
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error(`Error Sending Payments to ${integration}`, "Sending Payments");
			});
	};
};

const integrationUpdateSettings = (integration, body) => {
	return axios({
		method: "POST",
		url: `${apiURL}/integrations/${integration}/update-settings`,
		withCredentials: true,
		data: body,
	});
};

const integrationGetPayPeriods = (integration) => {
	return axios({
		method: "GET",
		url: `${apiURL}/integrations/${integration}/pay-periods`,
		withCredentials: true,
	});
};

const Actions = {
	sendPayment,
	switchEmployeeLink,
	linkEmployee,
	integrationGetList,
	toggleImportModal,
	openUserConnectedOrgsModal,
	getLinkedOrgIntegrations,
	disconnectLinkedOrg,
	integrationUpdateSettings,
	integrationGetPayPeriods,
	toggleBulkLinkModal,
};

export { Types, Actions };
